export default function getSafeIconName(base, name, separator = '_') {
	if (!base || !name) {
		return
	}
	return `${base}${separator}${name
		.replace(/&/g, 'and')
		.normalize('NFD') //decomposes combined graphemes into simple ones ex: 'é' as 'e + ´'
		.replace(/[\u0300-\u036f]/g, '') //get rid of combined diacritical marks ex: ´
		.replace(/[^a-zA-Z]/g, ' ')
		.replace(/[\s]+/g, separator)
		.toLowerCase()}`
}
